/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import { Breakpoint } from 'react-socks';
import { nextdoor as NextdoorIcon } from 'app/components/common/IconFactory.jsx';

class NextdoorWarningModal extends React.Component {
    constructor(props) {
        super(props);

        this.confirmClick = this.confirmClick.bind(this);
        this.draggableRef = React.createRef();

    }

    confirmClick(e) {

        this.props.confirmAction(e);

    }

    render() {
        let cancelButton = null,
            { confirmDataset } = this.props,
            confirmLabel = this.props.confirmLabel,
            imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl;

        cancelButton = (
            <div className="action-cancel" onClick={this.props.cancelAction} role="button" aria-label="close">
                {this.props.cancelLabel}
            </div>
        );

        return (
            <div className="dlvr-modal">
                <Breakpoint desktop only>
    				<Draggable nodeRef={this.draggableRef} handle=".dlvr-delete-modal" cancel=".dlvr-delete-close, .action-cancel, .action-confirm">
    					<div ref={this.draggableRef} className="dlvr-delete-modal">
                            <div className="dlvr-delete-close" onClick={this.props.closeAction || this.props.cancelAction} role="button" aria-label='close'>
                                <i className="fa fa-times"></i>
                            </div>
                            <div className="dlvr-delete-copy">
                                <div className="modal-icon">
                                    <NextdoorIcon large={true} round={true}/>
                                </div>
                                <div className="headline">
                                    Heads up, only Nextdoor Public Agency accounts are currently eligible.
                                </div>
                                <div className="subhead">
                                    Learn more about creating a <a href="https://help.nextdoor.com/s/article/what-is-the-nextdoor-for-public-agencies-program?language=en_US" target="_blank">Nextdoor Public Agency account.</a>
                                </div>

                            </div>
                            <div className="dlvr-delete-actions ig-modal">
                                {cancelButton}
                                <button className="btn-confirm action-confirm" {...confirmDataset} onClick={this.confirmClick}>
                                    {this.props.confirmLabel}
                                </button>
                            </div>
    					</div>
    				</Draggable>
                </Breakpoint>
                <Breakpoint mobile only>
					<div className="dlvr-delete-modal">
                        <div className="dlvr-delete-close" onClick={this.props.closeAction || this.props.cancelAction}>
                            <i className="fa fa-times"></i>
                        </div>
                        <div className="dlvr-delete-copy">
                            <div class-name="modal-icon">
                                <img width="150" height="57" src={imageUrl + '/misc/ig-fb.png'} srcSet={imageUrl + '/misc/ig-fb@2x.png' + " 2x"}/>
                            </div>
                            <div className="headline">
                                Heads up, your Instagram Business or Creator accounts need to be connected to Facebook.
                            </div>
                            <div className="subhead">
                                Facebook requires all Instagram Professional accounts to be associated with a Facebook Page.
                                Check out our <a href="https://support.dlvrit.com/hc/en-us/articles/1260803288509-How-do-I-change-my-Instagram-Personal-account-to-a-Business-Account-" target="_blank">Instagram Connection guide.</a>
                            </div>
                            <div className="fineprint">
                                On the next step, log into the Facebook profile that manages the Facebook page affiliated with your Instagram Business or Creator account.
                            </div>
                        </div>
                        <div className="dlvr-delete-actions">
                            {cancelButton}
                            <button className="btn-confirm action-confirm" {...confirmDataset} onClick={this.confirmClick}>
                                {this.props.confirmLabel}
                            </button>
                        </div>
					</div>
                </Breakpoint>
			</div>
        );
    }

};

NextdoorWarningModal.propTypes = {
    modalCopy: PropTypes.string,
    cancelAction: PropTypes.func,
    confirmAction: PropTypes.func,
    context: PropTypes.string
};

NextdoorWarningModal.defaultProps = {
    modalCopy: '',
    cancelAction: null,
    confirmAction: null,
    closeAction: null,
    confirmLabel: 'Connect Nextdoor Agency',
    cancelLabel: 'cancel',
    context: 'default',
    showCancel: true
};

export default NextdoorWarningModal;
